var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('checkbox',{attrs:{"value":_vm.inputValue,"disabled":!_vm.toggleEnabled,"theme":_vm.CheckboxTheme.SECONDARY},on:{"input":_vm.onInput}})}
var staticRenderFns = []

export { render, staticRenderFns }